import React from 'react';
import { MenuItem } from '@blueprintjs/core';
import i18n from 'i18n';

const advancedSelectCreateItemRenderer = (
  query: string,
  active: boolean,
  handleClick: React.MouseEventHandler<HTMLElement>,
): JSX.Element | undefined => {
  return (
    <MenuItem
      icon="add"
      text={i18n.t('advancedSelect.create', { name: query })}
      active={active}
      onClick={handleClick}
      shouldDismissPopover={false}
    />
  );
};

export default advancedSelectCreateItemRenderer;
